import React from "react";
import LottieView from "react-native-web-lottie";

export default function Lottie(props) {
  const { animationRef } = props;
  return <LottieView ref={animationRef} {...props} />;
}
